export const filteredParametersByBags = (parameters?: IProductParameterModel[]) => {
	if (!parameters) return []
	const bagsParameterNames = ['Big Bags Capacity', 'Small Bags Capacity']
	const $t = useI18n().t
	const bigBagsParameter = parameters?.find((parameter) => parameter.name === 'Big Bags Capacity')
	const smallBagsParameter = parameters?.find((parameter) => parameter.name === 'Small Bags Capacity')

	const bagTextByCount = (count: number) => {
		let bag
		let small
		let big

		if (count === 1) {
			bag = $t('components.car_parameters.bag.one')
			small = $t('components.car_parameters.small.one')
			big = $t('components.car_parameters.big.one')
		} else if (count > 1 && count < 5) {
			bag = $t('components.car_parameters.bag.two')
			small = $t('components.car_parameters.small.two')
			big = $t('components.car_parameters.big.two')
		} else {
			bag = $t('components.car_parameters.bag.more')
			small = $t('components.car_parameters.small.more')
			big = $t('components.car_parameters.big.more')
		}

		return { bag, small, big }
	}

	const bagsParamText = (bigBag?: IProductParameterModel, smallBag?: IProductParameterModel) => {
		const bigBagCount = Number(bigBag?.value)
		const smallBagCount = Number(smallBag?.value)

		if (bigBag && smallBag) {
			return `${bigBag.value} ${bagTextByCount(bigBagCount).big} ${bagTextByCount(bigBagCount).bag}, ${smallBag.value} ${bagTextByCount(smallBagCount).small}`
		} else if (bigBag) {
			return `${bigBag.value} ${bagTextByCount(bigBagCount).big} ${bagTextByCount(bigBagCount).bag}`
		} else if (smallBag) {
			return `${smallBag.value} ${bagTextByCount(smallBagCount).small} ${bagTextByCount(smallBagCount).bag}`
		}
	}

	const customBagsParameter = {
		name: 'Trunk Capacity',
		value: bagsParamText(bigBagsParameter, smallBagsParameter),
	}

	const filteredParameters = parameters.filter((parameter) => !bagsParameterNames.includes(parameter.name))

	if (bigBagsParameter || smallBagsParameter) {
		return [...filteredParameters, customBagsParameter]
	} else {
		return filteredParameters
	}
}
